if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const currencyRate = Shopify.currency.rate ? Number(Shopify.currency.rate) : 1;
      const freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * currencyRate);
      const priorityShippingThreshold = Math.round(Number(this.getAttribute('data-priority-shipping')) * currencyRate);
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const hasPriorityTier = priorityShippingThreshold > freeShippingThreshold;
      const finalThreshold = hasPriorityTier ? priorityShippingThreshold : freeShippingThreshold;
      const locales = window.KROWN.settings.locales;

      let message = '';
      if ( cartTotal < freeShippingThreshold ) {
        const remaining = freeShippingThreshold - cartTotal;
        message = locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(remaining, KROWN.settings.shop_money_format));
      } else if ( hasPriorityTier && cartTotal < priorityShippingThreshold ) {
        const remaining = priorityShippingThreshold - cartTotal;
        message = locales.shipping_notice_remaining_to_priority.replace('{{ remaining_amount }}', this._formatMoney(remaining, KROWN.settings.shop_money_format));
      } else if ( hasPriorityTier ) {
        message = locales.shipping_notice_eligible_for_priority;
      } else {
        message = locales.shipping_notice_eligible_for_free;
      }

      let cartSliderWidth = finalThreshold > 0 ? (cartTotal * 100 / finalThreshold) : 0;
      cartSliderWidth = Math.max(0, Math.min(100, cartSliderWidth));

      this.querySelector('[data-js-free-shipping-text]').innerHTML = message;

			const slider = this.querySelector('[data-js-free-shipping-slider]');
			if ( slider ) {
				slider.style.width = `${cartSliderWidth}%`;
			}

			const track = this.querySelector('.kt-cart-notice__slider') || slider;
			if ( track ) {
				track.setAttribute('role', 'progressbar');
				track.setAttribute('aria-valuemin', '0');
				track.setAttribute('aria-valuemax', '100');
				track.setAttribute('aria-valuenow', String(Math.round(cartSliderWidth)));
				track.setAttribute('aria-valuetext', message.replace(/<[^>]*>/g, ''));
			}

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}